<script>
import axios from 'axios'
import Vue from 'vue'
let TiposEquiposModel = new Vue({
  name: 'TiposEquipos',
  methods: {
    obtener() {
      return new Promise(async (resolve, reject) => {
        try {
          let tiposEquipos = (await axios.get('../../catalogos/tiposEquipos.txt'))
            .data.split('\n')
          resolve(tiposEquipos)
        } catch (e) {
          console.error("ETIPOS", e)
          reject(e)
        }
      })
    }
  }
})
export default TiposEquiposModel
</script>
